import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {partnersActions} from '..';
import useIsMountedRef from '../../../common/hooks/useIsMountedRef';
import {IPartner} from 'types/partners';

const actionsMap = {
   pgp: partnersActions.getRefsPgp,
   ssh: partnersActions.getRefsSsh,
   ssl: partnersActions.getRefsSsl,
   proxy: partnersActions.getRefsProxy,
};

export const usePartnersRefs = (id: string, keyType: 'pgp' | 'ssh' | 'ssl' | 'proxy') => {
   const isMountedRef = useIsMountedRef();
   const dispatch = useDispatch();
   const [partners, setPartners] = useState<IPartner[]>([]);
   useEffect(() => {
      const action = actionsMap[keyType];
      dispatch(
         action(id, {
            onSuccess: ({partners}) => {
               if (isMountedRef.current) {
                  setPartners(partners);
               }
            },
         })
      );
   }, [dispatch, id, isMountedRef, keyType]);

   return partners;
};
